import FeatureGate from "@/src/components/feature-gate";
import NewsCreationScreen from "@/src/screens/news/news-creation-screen/news-creation-screen";

export default function NewsCreation() {
  return (
    <FeatureGate feature="news">
      <NewsCreationScreen />
    </FeatureGate>
  );
}
